export const locale = {
  refreshPage: 'Refresh This Page',
  goBack: 'Go Back',
  goHome: 'Portal Homepage',
};
